import { useQuery } from "@tanstack/react-query";
import { fetchContacts } from "../services/contactsServices";
import { format, parse } from "date-fns";

const parseStartDateCreated = (dateString) => {
  const input = dateString; // DD/MM/YYYY
  const parsedDate = parse(input, "dd/MM/yyyy", new Date());
  if (isNaN(parsedDate)) {
    return null; // Handle invalid date
  }
  const output = format(parsedDate, "MM/dd/yyyy");

  return output;
};

const useContacts = () => {
  const { data: contacts, isLoading, isError } = useQuery({
    queryKey: ["contacts"],
    queryFn: fetchContacts,
  });

  const formattedContacts = contacts?.map(contact => ({
    ...contact,
    dateCreated: contact.dateCreated ? parseStartDateCreated(contact.dateCreated) : null,
   
  })) || [];

  return { contacts: formattedContacts, isLoading, isError };
};

export default useContacts;
